import { Branch } from "../branch";

export class User {
  address: string = "";
  avatar: string = "";
  birthday: string = "";
  // branches: Branch = new Branch();
  branches: Branch[] = [];
  company_id: number = 0;
  created_at: string = "";
  department_id: number = 0;
  department_name: string = "";
  email: string = "";
  gender: number = 0;
  id: number = 0;
  is_owner: number = 0;
  joining_date: string = "";
  manager_id: number = 0;
  manager_name: string = "";
  name: string = "";
  phone: string = "";
  privilege_group_id: number = 0;
  status: number = 0;
  updated_at: string = "";
  username: string = "";
  password: string = "";
  access_token: string = "";
  totp_qr_code: string = "";
  totp_secret: string = "";
  id_card_number: string = "";
  privilege_codes: string[] = [];
  // salary_level: { id: number, name: string, total_amount: number } = {
  //   id: 0,
  //   name: '',
  //   total_amount: 0
  // }
  // salary_level_id: number = 0
  privilege_group_name: string = ''
   is_2fa: number=0

  constructor(data?: Partial<User>) {
    Object.assign(this, data);
  }
}
